// 📁 src/admin/vehicles/Pricing.js
import React from 'react';

const VehiclePricing = () => {
  return (
    <div>
      <h2>Vehicle Pricing</h2>
      <p>Update pricing for different distances here.</p>
    </div>
  );
};

export default VehiclePricing;